import React from 'react';
import { observable, computed } from 'mobx';
import { observer } from 'mobx-react';
import classNames from 'classnames';

import { Button } from '@smartplatform/ui';
import { getPlenaryQuestionData, getCommitteeQuestionData } from '../helpers';
import voting from '../store-admin';
import './style.scss';

@observer
export default class QuestionCard extends React.Component {

	@observable name = '';
	@observable files = [];
	@observable isLoading = true;
	
	constructor(props) {
		super(props);
		this.init();
	}
	
	init = async () => {
		const { name, files } = this.props.question.questionId ?
			await getPlenaryQuestionData(this.props.question.questionId)
			:
			this.props.question.documentId ?
				await getCommitteeQuestionData(this.props.question.documentId)
				:
				{ name: 'error', files: [] };
		
		this.name = name;
		this.files = files;
		this.isLoading = false;
		if (this.el) {
			if (this.isActive) {
				setTimeout(() => {
					this.el.parentNode.scrollTop = this.el.offsetTop;
				}, 1000);
			}
		}
	};
	
	@computed get isActive() {
		console.log('isActive', voting.session.questionId);
		return this.props.question.id === voting.session.questionId;
		// return this.props.question.order === 3;
	}
	
	onMount = el => {
		this.el = el;
	};
	
	showFiles = () => {
		console.log('showFiles');
	};
	
	render() {
		const { question } = this.props;
		let status = 'inactive';
		let statusName = 'ожидание';
		
		if (question.end) {
			status = question.statusId === 1 ? 'yes' : question.statusId === 2 ? 'no' : 'canceled';
			statusName = question.statusId === 1 ? 'принят' : question.statusId === 2 ? 'не принят' : 'голосование отменено';
		}
		else if (question.voteStart) {
			status = 'voting';
			statusName = 'идет голосование';
		}
		else if (question.discussionStart) {
			status = 'discussion';
			statusName = 'идет обсуждение';
		}
		
		const className = classNames('question-card', {
			active: this.isActive,
		});
		
		return <div className={className} ref={this.onMount}>
			<div className="left">
				<div className={'status ' + status}>
					<span className="disc" />
					Вопрос №{question.order}: {statusName}
				</div>
				<div className="name">{this.name}</div>
				<ul className="files">
					{this.files.map(file => {
						if (!file.url && !file.pages) return null;
						let link = file.url ?
							<a target="_blank" href={file.url}>{file.name}</a>
							:
							<a href="#" onClick={this.showFiles}>{file.name}</a>
						return <li key={file.id}>{link}</li>;
					})}
				</ul>
			</div>
			<div className="right">
				<div>id: {question.id}</div>
				<Button onClick={() => voting.startDiscussion(question)}>Начать обсуждение</Button>
			</div>
		</div>;
	}
	
}
